import { render, staticRenderFns } from "./MagisterForm.vue?vue&type=template&id=5f0f5cb4&scoped=true"
import script from "./MagisterForm.vue?vue&type=script&lang=js"
export * from "./MagisterForm.vue?vue&type=script&lang=js"
import style0 from "./MagisterForm.vue?vue&type=style&index=0&id=5f0f5cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f5cb4",
  null
  
)

export default component.exports